import { Input } from '@billy/design-system'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import { useCustomerForm } from '../../../../contexts/customerFormContext'
import { ShippingAddressInputFieldProps } from '../../types/shippingAddressInputFieldProps'

type ShippingAddressPoboxProps = ShippingAddressInputFieldProps

export const ShippingAddressPobox = ({ isDisabled }: ShippingAddressPoboxProps): ReactElement => {
  const { t } = useTranslation()
  const { customerForm } = useCustomerForm()
  const { FormItem } = customerForm

  return (
    <FormItem
      label={t('customer_modal.form.shipping_address.pobox.label')}
      name="shippingAddress.pobox"
      render={({ field }) => <Input {...field} disabled={isDisabled} size="sm" />}
    />
  )
}
